import React from 'react';
import { Autocomplete, createFilterOptions, TextField } from '@mui/material';

const filter = createFilterOptions();

const AutocompleteCreatable = ({ options, paramsKey, value, onFieldChange, resetErrorKey, optionKey = 'label', label, required, error, multiple = false, helperText, autoCompleteWidth, disableClearable, filterSelected, variant, placeholder, noOptionsText, isDisabled=false,useLimitTags=100 }) => {
    return (
        <Autocomplete
            value={value}
            noOptionsText={noOptionsText ? noOptionsText : 'No options, please type to create new'}
            // onChange={(e, newValue) => {
            //     const normalized = newValue.map((item) => {
            //         if (typeof item === 'string') return item;
            //         if (item?.inputValue) return item.inputValue;
            //         if (item?.label) return item.label;
            //         if (item?.name) return item.name;
            //         return '';
            //     }).filter(Boolean);

            //     onFieldChange(e, paramsKey, normalized);
            // }}

            const onChange={(e, newValue) => {
                // ✅ handle both multiple and single select
                if (multiple) {
                    const normalized = (newValue || []).map((item) => {
                        if (typeof item === 'string') return item;
                        if (item?.inputValue) return item.inputValue;
                        if (item?.label) return item.label;
                        if (item?.name) return item.name;
                        return '';
                    }).filter(Boolean);

                    onFieldChange(e, paramsKey, normalized);
                } else {
                    // single select → newValue can be null or object
                    let val;
                    if (newValue === null) val = null;
                    else if (typeof newValue === 'string') val = { label: newValue, value: newValue };
                    else if (newValue?.inputValue) val = { label: newValue.inputValue, value: newValue.inputValue };
                    else val = newValue;

                    onFieldChange(e, paramsKey, val);
                }
            }}

            options={options}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);

                if (filtered.length === 0 && params.inputValue !== '') {
                    filtered.push({
                        inputValue: params.inputValue,
                        [optionKey]: `Add "${params.inputValue}"`,
                    });
                }
                return filtered;
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') return option;
                if (option.inputValue) return option.inputValue;
                return option[optionKey] || ''; // ✅ dynamically use your key
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    {typeof option === 'string' ? option : option[optionKey]}
                </li>
            )}
            id={paramsKey}
            freeSolo={false}
            filterSelectedOptions={filterSelected ?? true}
            disableClearable={disableClearable ?? false}
            disabled={isDisabled}
            limitTags={useLimitTags}
            renderInput={(params) => (
                <TextField
                    style={{ width: autoCompleteWidth }}
                    required={required}
                    error={!!error}
                    helperText={error ? error : helperText || ''}
                    {...params}
                    onFocus={resetErrorKey}
                    label={label || ''}
                    margin="normal"
                    fullWidth
                    placeholder={placeholder}
                    InputLabelProps={{ shrink: true }}
                    variant={variant || 'outlined'}
                    size="small"

                />
            )}
            multiple={multiple}
        />
    );
};

export default AutocompleteCreatable;
